import * as Yup from 'yup';

import { fixGoSlice } from '../helpers/fix-go-types';

export const ReceiptItemSchema = Yup.object().shape({
  code_num: Yup.string().defined(),
  product: Yup.string().defined(),
  size: Yup.string().defined(),
  barcode: Yup.string().defined(),
  price: Yup.number().defined(),
  quantity: Yup.number().defined(),
  discount: Yup.number().defined(),
  cost: Yup.number().defined(),
});

export type ReceiptItem = Yup.InferType<typeof ReceiptItemSchema>;

export const PaymentInfoSchema = Yup.object().shape({
  type: Yup.string()
    .oneOf(['cash', 'card', 'check', 'gift_card', 'other'] as const)
    .defined(),
  card_brand: Yup.string().optional(),
  card_last4: Yup.string().optional(),
});

export type PaymentInfo = Yup.InferType<typeof PaymentInfoSchema>;

export const ReceiptSchema = Yup.object().shape({
  invoice_number: Yup.number().required(),
  timestamp: Yup.date().required(),
  station: Yup.string().defined(),
  initials: Yup.string().defined(),
  closing_id: Yup.string().defined(),
  // Go serializes a nil `[]ReceiptItem` (no omitempty) as `null`; fixGoSlice
  // coerces that to `[]` so a receipt with no lines still validates.
  items: Yup.array().of(ReceiptItemSchema).defined().transform(fixGoSlice),
  sub_total: Yup.number().defined(),
  tax: Yup.number().defined(),
  total: Yup.number().defined(),
  payment: PaymentInfoSchema.optional().default(undefined),
  payment2: PaymentInfoSchema.optional().default(undefined),
});

export type Receipt = Yup.InferType<typeof ReceiptSchema>;
